import React from 'react';

function SafarGlimpseLogo({ variant = 'dark', height = 48, className, style }) {
  const isDark = variant === 'dark';
  const mainColor = isDark ? '#ffffff' : '#1a3a2a';
  const taglineColor = isDark ? 'rgba(255,255,255,0.7)' : '#3a5a4a';

  // Scale based on height
  const scale = height / 48;
  const width = Math.round(320 * scale);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 320 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      role="img"
      aria-label="Safar Glimpse - Discover The World, Unearth Its Wonders"
    >
      <text
        x="0"
        y="28"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="28"
        fontWeight="700"
        fill={mainColor}
        letterSpacing="-0.5"
      >
        Safar Glimpse
      </text>
      <text
        x="0"
        y="44"
        fontFamily="'Helvetica Neue', Arial, sans-serif"
        fontSize="7.5"
        fontWeight="600"
        fill={taglineColor}
        letterSpacing="2.5"
        textTransform="uppercase"
      >
        DISCOVER THE WORLD, UNEARTH ITS WONDERS
      </text>
    </svg>
  );
}

export default SafarGlimpseLogo;
